import { Stack, Typography } from "@mui/material";
import React from "react";

interface ListItemProps {
  label: string | React.ReactNode;
  value: string;
}

export function SubtotalListItem(props: ListItemProps) {
  return (
    <Stack
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      py="4px"
    >
      <Typography variant="body1" color="text.secondary" fontWeight={600}>
        {props.label}
      </Typography>

      <Typography variant="body1" color={"text.primary"} fontWeight={600}>
        {props.value}
      </Typography>
    </Stack>
  );
}
